import { useTranslation } from "@msuite/ui/localization";
import { Spinner } from "@msuite/ui/spinner";
import { Tag } from "@msuite/ui/tag";
import { getEmailStateColor, getEmailStateTranslationKey } from "@msuite/utils/emails";
import { useEmailState } from "@/hooks/use-email-state";

/** Props Interface */
interface EmailStateTagProps {
	emailId: string;
}

export function EmailStateTag({ emailId }: EmailStateTagProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { state } = useEmailState(emailId);

	if (!state) return <Spinner />;

	return (
		<Tag
			color={getEmailStateColor(state)}
			variant="plain"
		>
			{t(getEmailStateTranslationKey(state))}
		</Tag>
	);
}
